import axios from "axios";

export default class Events {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async getAllEvents(history) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/event?history=${history}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getEventById(id) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/event/${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async getGuestsByStatus(params, id) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/event/users/search/${id}?filter=${
          params.filter
        }&limit=${params.limit}&page=${params.page}`,
        data: { query: params.query }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async createEvent(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/event`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async sendExternalUsersInvitation(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/event/externalUser`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async editEvent(params, id) {
    try {
      const response = await axios({
        method: "patch",
        url: `${this.API_LINK}/event/${id}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async markAsEntered(code, id) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/event/qr/${code}?eventId=${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async markAsConfirmed(id) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/event/users/waiting/${id}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async enterManually(params, id) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/event/${id}`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async assignUsersToSurvey(params) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/surveys/assingUsers`,
        data: params
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  async downloadEventTable(id, table) {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/event/users/search/${id}?filter=${table}`
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
